import React, { useEffect, useState } from "react";
import './Color.scss';

type ColorProps = {
    className?: string,
    label: string,
    value: string,
    onChange: (value: string) => void,
};

function Color(props: ColorProps) {
    const [value, setValue] = useState<string>(props.value);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.target.value);
        setValue(e.target.value);
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div className={`color ${props.className ?? ''}`}>
            <span className="color-label">{props.label}</span>
            <input type="color" onChange={handleChange} value={value}/>
        </div>
    );
}

export default Color;
